import { render, staticRenderFns } from "./template.vue?vue&type=template&id=20b12cbc&scoped=true&"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=20b12cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b12cbc",
  null
  
)

export default component.exports